var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.consent && _vm.isShow)?_c('div',{staticClass:"modal-cookie-consent"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.data.title))]),_c('div',{staticClass:"detail",domProps:{"innerHTML":_vm._s(_vm.data.detail)}}),_c('a',{staticClass:"btn-accept",on:{"click":_vm.closeConsent}},[_vm._v(_vm._s(_vm.data.accept))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }